export default {
  namespaced: true,
  schedule_alarm: {
    title: "programación de alarma | programación de alarmas",
    name: "nombre",
    apply_holliday: "aplicar días festivos",
    allow_alarms: "permitir alarmas",
    replicate_all_days: "Replicar a todos los días",
    select_all_units: "Seleccionar todas las instalaciones",
    clear_all_units: "Quitar todas las instalaciones",
    loading_all_units: "Buscando instalaciones...",
    day: 'día',
    month: 'mes',
    months: {
      january: 'enero',
      february: 'febrero',
      march: 'marzo',
      april: 'abril',
      may: 'mayo',
      june: 'junio',
      july: 'julio',
      august: 'agosto',
      september: 'septiembre',
      october: 'octubre',
      november: 'noviembre',
      december: 'diciembre',
    },
  },
}
